import type { Candle, OverlaySpec, PanelSpec } from "../types";
import type { StructureFlags, StructureResult } from "../structure/types";
import type { DrawingObject, ToolId } from "../drawings/types";

export type ChartType = "candlestick" | "hollow" | "ohlc" | "line" | "area" | "heikin";
export type { ToolId, DrawingObject as Drawing } from "../drawings/types";

export interface ChartPoint { index: number; price: number }

export interface ChartOptions {
  chartType: ChartType;
  overlays: OverlaySpec[];
  panels: PanelSpec[];
  showVolume: boolean;
  structure: StructureResult | null;
  structureFlags: StructureFlags;
  drawings: DrawingObject[];
  activeTool: ToolId;
  snap: boolean;
  theme: string;
  decimals: number;
  scaleMode?: "normal" | "percent" | "log"; // price-axis transform (log) / labelling (percent vs last close)
  tfSeconds: number;
}

export const DEFAULT_OPTIONS: ChartOptions = {
  chartType: "candlestick",
  overlays: [],
  panels: [],
  showVolume: true,
  structure: null,
  structureFlags: { swings: false, bos: true, choch: true, twoBOneA: false, fvg: false, ob: false, liq: false },
  drawings: [],
  activeTool: "cross",
  snap: true,
  theme: "dark",
  decimals: 2,
  tfSeconds: 60,
};

export type CandleData = Candle[];
